import NotificationsConfig from './NotificationsConfig';

export default NotificationsConfig;